import React from "react";
import { Accordion } from "react-accessible-accordion";

export const AttributeFiltersComponent: React.FC = ({ children }) => {
  return (
    <div className="attribute-filter-accordion">
      <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
        {children}
      </Accordion>
    </div>
  );
};
